export default "__VITE_ASSET__BCH9WXw0__"